import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface ISiteFields {
		id?: any;
		name?: any;
		prefix?: any;
		datestamp?: any;
		changedBy?: any;
		status?: any;
		address?: any;
}

export class SiteFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public name: IEntityModelField = { name: "name", displayName: "Name", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public prefix: IEntityModelField = { name: "prefix", displayName: "Prefix", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric" };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric" };
	public address: IEntityModelField = { name: "address", displayName: "Address", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.name);
		this.push(this.prefix);
		this.push(this.datestamp);
		this.push(this.changedBy);
		this.push(this.status);
		this.push(this.address);
	}
}

export class SiteDTO implements IEntityModel {
	protected siteName: string = "SiteModel";
	protected siteKeyField: string = "id";
	protected siteDisplayName: string = "Site|Sites";
	protected siteFields = new SiteFields();
	public get name(): string { return this.siteName };
	public get keyField(): string { return this.siteKeyField };
	public get displayName(): string { return this.siteDisplayName };
	public get fields(): SiteFields { return this.siteFields };

	constructor() {};
}
